import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  icon = "ri-fire-line",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4 border-b border-background-200 pb-3">
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
          <i className={`${icon} text-lg`} aria-hidden="true" />
        </span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle && <p className="mt-0.5 text-xs text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}